<template>
  <v-skeleton-loader
    :loading="loading"
    type="heading, table-thead, table-row-divider@8"
  >
    <v-card>
      <v-card-title class="py-0">
        <h2 class="text-h2 mt-10 mb-7">
          {{ $t('rateConfigurationStrings.salaryTitle') }}
        </h2>
      </v-card-title>
      <v-card-text>
        <v-row>
          <v-col
            cols="12"
            lg="8"
            xl="6"
          >
            <v-table>
              <template #default>
                <thead>
                  <tr>
                    <th class="text-left">
                      {{ $t('rateConfigurationStrings.salaryActiveHeader') }}
                    </th>
                    <th class="text-left">
                      {{ $t('rateConfigurationStrings.salaryTypeHeader') }}
                    </th>
                    <th class="text-left">
                      {{ $t('rateConfigurationStrings.salaryAccountingHeader') }}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="item in filteredSalaryRateTypes"
                    :key="item.rateType"
                  >
                    <td>
                      <vee-field
                        v-slot="{ componentField }"
                        v-model="item.enabled"
                        rules
                        :vid="getSalaryEnabledValidationId(item.rateType)"
                      >
                        <v-checkbox
                          v-bind="componentField"
                          color="primary"
                          :aria-label="$t('commonStrings.tableAriaLabel',[$t('rateConfigurationStrings.salaryActiveHeader'), $t(`enums.salaryTypes.${item.rateType}`)])"
                        />
                      </vee-field>
                    </td>
                    <td>{{ $t(`enums.salaryTypes.${item.rateType}`) }}</td>
                    <td>
                      <vee-field
                        v-slot="{ componentField, errors }"
                        v-model="item.accountingId"
                        rules="finance_account"
                        :name="$t('rateConfigurationStrings.salaryAccountingHeader')"
                        :vid="getSalaryAccountingIdValidationId(item.rateType)"
                      >
                        <v-text-field
                          v-bind="componentField"
                          variant="outlined"
                          density="compact"
                          :error-messages="errors"
                          :aria-label="$t('commonStrings.tableAriaLabel',[$t('rateConfigurationStrings.salaryAccountingHeader'), $t(`enums.salaryTypes.${item.rateType}`)])"
                          :disabled="!item.enabled"
                        />
                      </vee-field>
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-table>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-skeleton-loader>
</template>

<script>
import { Field as VeeField } from "vee-validate";
import SalaryTypes from '../../../enums/SalaryTypes';

export default {
  name: "SalarySettings",
  components: {
    VeeField
  },
  props: {
    loading: {
      type: Boolean,
      required: true
    },
    salaryRates: {
      type: Object,
      required: true
    }
  },
  computed: {
    filteredSalaryRateTypes() {
      return this.salaryRates.salaryRateTypes.filter(x => x.rateType === SalaryTypes.Default);
    }
  },
  methods: {
    getSalaryEnabledValidationId(rateType) {
      return `enabled_salaryType_${rateType}`;
    },
    getSalaryAccountingIdValidationId(rateType) {
      return `accountingId_salaryType_${rateType}`;
    }
  }
};
</script>
